export default {
  meta: {
    titleTemplate: '%s | IEFA'
  },
  brand: 'The International Economic Forum of the Americas',
  brandSmall: 'IEFA',
  nextEvent: 'Next event',
  banner: 'Watch the Toronto Global Forum Live Now',
  navigation: {
    home: 'Home',
    events: 'Events',
    eventNext: 'View next event',
    eventsNext: 'Next events',
    allEvents: 'All Events',
    eventsAnnual: 'Conferences',
    about: 'About',
    aboutUs: 'About us',
    services: 'Services',
    team: 'Our team',
    teamShort: 'Team',
    partner: 'Partner',
    becomePartner: 'Become a Partner',
    terms: 'Terms of use',
    privacy: 'Privacy policy',
    consulting: 'IEFA Consulting',
    seeMore: 'See more',
    gallery: 'Photo gallery',
    galleryShort: 'Gallery',
    close: 'Close'
  },
  cta: {
    learnMore: 'Learn more',
    contact: 'Contact us',
    tickets: 'Registration',
    registerNow: 'Register now'
  },
  city: {
    montreal: 'Montreal',
    toronto: 'Toronto',
    paris: 'Paris',
    miami: 'Miami',
    buenosAires: 'Buenos Aires',
    phoenix: 'Phoenix'
  },
  form: {
    name: 'Name',
    email: 'Email',
    company: 'Company',
    phone: 'Phone number',
    subject: 'Subject',
    getTouch: 'Get in touch',
    partner: 'Become a partner',
    message: 'Message',
    button: 'Submit',
    tollFree: 'Toll free'
  },
  copyright: 'The International Economic Forum of the Americas',
  cretedBy: 'Website created by',
  languages: {
    title: 'Languages',
    french: 'French',
    english: 'English',
    spanish: 'Spanish'
  },
  logo: '/images/brand/logo-en-white.png',
  logoSmall: '/images/brand/logo-small-en-white.png',
  boardOfGovernors: 'Board of Governors',
  advisoryBoard: 'Advisory Board',
  archives: 'Archives',
  ourPurpose: 'Our Purpose',
  pastEvents: 'Past Events'
}
